export default {"src":"/_next/static/media/Forward.45cc8e0d.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};